import { SideMenuI } from '../../shared/interfaces/side-menu.interface';

export const MERCHANT_SIDE_MENU_ITEMS: SideMenuI[] = [
  {
    title: 'Overview',
    route: 'overview',
    translationPath: 'sideMenu.merchantOverview',
    activeIcon: 'svgs/side-menu/active-merchant-overview.svg',
    inactiveIcon: 'svgs/side-menu/inactive-merchant-overview.svg',
    roles: [],
  },
  {
    title: 'Commission',
    route: 'commission',
    translationPath: 'sideMenu.merchantCommission',
    activeIcon: 'svgs/side-menu/active-commission.svg',
    inactiveIcon: 'svgs/side-menu/inactive-commission.svg',
    roles: [],
  },
  {
    title: 'Orders',
    route: 'orders',
    translationPath: 'sideMenu.merchantOrders',
    activeIcon: 'svgs/side-menu/active-merchant-orders.svg',
    inactiveIcon: 'svgs/side-menu/inactive-merchant-orders.svg',
    roles: [],
  },
  {
    title: 'Products',
    route: 'products',
    translationPath: 'sideMenu.merchantProducts',
    activeIcon: 'svgs/side-menu/active-merchant-products.svg',
    inactiveIcon: 'svgs/side-menu/inactive-merchant-products.svg',
    roles: [],
  },
  {
    title: 'Supports',
    route: 'supports',
    translationPath: 'sideMenu.supports',
    activeIcon: 'svgs/side-menu/active-notifications.svg',
    inactiveIcon: 'svgs/side-menu/inactive-notifications.svg',
    roles: [],
  },
];
